import { render, staticRenderFns } from "./SettingsMenuItem.vue?vue&type=template&id=90a3b2ac&scoped=true"
import script from "./SettingsMenuItem.vue?vue&type=script&lang=js"
export * from "./SettingsMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a3b2ac",
  null
  
)

export default component.exports